import { fetchData } from '../utils/fetchData';
import { RESOURCES, API_BASE_URL } from '../utils/constants/constants';

export const getRiskControls = () => {
  const resource = `${API_BASE_URL}${RESOURCES.risk.controls}`;
  return fetchData(resource);
};
